module.exports = "<h2 mat-dialog-title>{{data.lugar | titlecase}} | {{data.posicion | titlecase}}</h2>\r\n\r\n<img [src]=\"data.src\" alt=\"\">\r\n"